import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'enumSelect'
})
export class EnumSelectPipe implements PipeTransform {
    transform(value: any, args: string[]): any { //value should be an enum type
        const keys = [];
        for (let key in value) {
            //An enum is a mapping from the names to the ints, and from the ints to the names. Only pick out the first mapping.
            if (typeof(value[key]) === 'number') {
                keys.push({ key: key, value: value[key] });
            }
        }
        return keys;
    }
}

@NgModule({
    declarations: [EnumSelectPipe],
    exports: [EnumSelectPipe]
})
export class EnumSelectPipeModule {}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/pipes/enumselectpipe/enumSelectPipe.module.ts